import { ConfirmActionModal } from '@/shared/components/ui/modal/ConfirmActionModal';

interface Props {
  isOpen: boolean;
  documentLabel: string;
  dealerName?: string;
  isPending?: boolean;
  errorMessage?: string;
  onConfirm: () => void;
  onClose: () => void;
}

export function UnassignTemplateConfirm({ isOpen, documentLabel, dealerName, isPending = false, errorMessage, onConfirm, onClose }: Props) {
  const consequence = dealerName
    ? `${dealerName} will receive the product's ${documentLabel.toLowerCase()} template instead, if one is assigned.`
    : `Agreements on this product will no longer receive a ${documentLabel.toLowerCase()} unless a dealer override applies.`;

  return (
    <ConfirmActionModal
      isOpen={isOpen}
      title={`Unassign ${documentLabel.toLowerCase()}?`}
      message={
        <>
          <p>{consequence} Documents already generated are unchanged.</p>
          {errorMessage && <p role="alert" className="mt-2 text-mp-error">{errorMessage}</p>}
        </>
      }
      confirmLabel="Unassign"
      isPending={isPending}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
}
